import { Component, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { UserPropertyList } from '../user-property-list/user-property-list';
import { User } from '../../../models/user.model';
import { AsyncPipe, CommonModule } from '@angular/common';
import { AuthService } from '../../../../../core/services/auth.service';
import { map, Observable, startWith, tap } from 'rxjs';
import { GtmService } from '../../../../../core/services/gtm.service';
import { LoaderComponent } from '../../../../general/components/loader/loader.component';
import { HapticsService } from '../../../../general/services/haptics.service';

@Component({
  selector: 'app-manage-user-properties',
  imports: [
    CommonModule,
    MatCardModule,
    UserPropertyList,
    AsyncPipe,
    LoaderComponent
  ],
  templateUrl: './manage-user-properties.html',
  styleUrl: './manage-user-properties.scss',
})
export class ManageUserPropertiesComponent {
  private authService = inject(AuthService);
  private haptics = inject(HapticsService);
  private gtm = inject(GtmService);

  readonly user$: Observable<User | null>;
  readonly isLoading$: Observable<boolean>;

  constructor() {
    this.user$ = this.authService.user$.pipe(
      map(user => user ?? null),
      tap(() => this.trackPageView())
    );

    this.isLoading$ = this.authService.user$.pipe(
      map(user => user === undefined),
      startWith(true)
    );
  }
  
  trackPageView() {
    this.gtm.pageView({
      page_path: '/manage-user-properties',
      page_title: 'Horizinns | Manage User Properties',
      page_location: window.location.href
    });
  }
}
